import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

// Models
import { PaymentsData } from 'src/app/modules/payments/models/payments';
import { ScreenLoaderData } from 'src/app/platform/components/ui-screen-loader/ui-screen-loader.model';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { PaymentsService } from 'src/app/modules/payments/payments.service';
import { ListExportService } from 'src/app/platform/services/platform.service';

// Components
import { PaymentsReceiptComponent } from 'src/app/modules/payments/views/payments-receipt/payments-receipt.component';
import { MetaData } from 'src/app/platform/models/utils';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {
  public filters: any = {
    status: '',
    paymentMethod: '',
    date: { start: '', end: ''},
    datePayment: { start: '', end: ''}
  };
  public filterPaymentMethods: MetaData[] = [];
  public payments: PaymentsData[] = [];
  public paymentsTotal = 0;
  public paymentsPage = 1;
  public paymentsPageSize = 10;
  public paymentsUpdating = false;
  public paymentsInitStatus = false;
  public paymentsSelected: Array<boolean> = [];
  public paymentsSelectedAmount = '';
  public errors = {
    load: new ScreenLoaderData('Cargando pagos', 'Estamos buscando la información de tus pagos realizados.', 'local_atm', true),
    empty: new ScreenLoaderData('No existen pagos en tu cuenta', 'Aun no realizaste ningún pago. Cuando realices un pago prodras verlo reflejado aqui.', 'help_outline'),
    error: new ScreenLoaderData('Ocurrió un error al intentar cargar los pagos', 'No pudimos obtener tus pagos, estamos trabajando para solucionar este problema. Por favor intenta revisar nuevamente mas tarde.', 'highlight_off'),
  };

  constructor(
    private uiService: UiService,
    private uiDialog: MatDialog,
    private paymentsService: PaymentsService,
    private listExportService: ListExportService,
  ) { }

  ngOnInit(): void {
    this.uiService.screenLoaderSet(this.errors.load);

    this.paymentsLoad(this.paymentsPage, this.paymentsPageSize).then((success) => {
      if (success.registersTotal > 0) {
        this.paymentsInitStatus = true;
        this.payments = success.registers;
        this.paymentsTotal = success.registersTotal;
        this.paymentsPage = success.page;
      } else {
        this.uiService.screenLoaderSet(this.errors.empty);
      }
    }).catch((error) => {
      this.uiService.screenLoaderSet(this.errors.error);
    });

    this.paymentsService.callsTypesGet().then((success) => {
      this.filterPaymentMethods = success.result;
    }).catch((error) => {
      this.filterPaymentMethods = [new MetaData(0, 'Filtro no disponible')];
    });
  }

  private paymentsLoad(page: number | null = null, limit: number | null = null, filters: any | null = null): Promise<any> {
    return new Promise((resolve, reject) => {
      this.paymentsService.paymentsGet(page, limit, filters).then((success) => {
        resolve(success.result);
      }).catch(() => {
        reject(false);
      });
    });
  }

  private paymentsChange(): void {
    this.paymentsUpdating = true;

    this.paymentsLoad(this.paymentsPage, this.paymentsPageSize, this.filters).then((success) => {
      this.paymentsUpdating = false;

      if (success.registersTotal > 0) {
        this.payments = success.registers;
        this.paymentsTotal = success.registersTotal;
        this.paymentsPage = success.page;
      } else {
        this.payments = [];
      }
    }).catch((error) => {
      this.paymentsUpdating = false;
      this.payments = [];
      this.uiService.showSnackBar(this.errors.error.message);
    });
  }

  onFilterSelect(filter: string, value?: any): void {
    if (typeof this.filters[filter] !== 'undefined') {
      let update = true;

      if (filter === 'date' || filter === 'datePayment') {
        if (this.filters[filter].end === '' || this.filters[filter].end === null) {
          update = false;
        }

        if (value === '') {
          this.filters[filter] = {start: '', end: ''};
          update = true;
        }
      } else {
        this.filters[filter] = value;
      }

      if (update) {
        this.paymentsPage = 1;

        this.paymentsChange();
      }
    }
  }

  onPaginationChange(event: PageEvent): void {
    this.paymentsPage = event.pageIndex + 1;
    this.paymentsPageSize = event.pageSize;

    this.paymentsChange();
  }

  onViewDetails(payment: PaymentsData): void {
    this.uiDialog.open(PaymentsReceiptComponent, {
      width: '400px',
      data: {
        payment
      }
    });
  }

  onExport(type: string): void {
    this.uiService.showSpinner(true);

    this.paymentsLoad(1, null, this.filters).then((success) => {
      if (success.registersTotal > 0) {
        const items: any = [];

        success.registers.forEach((item: any) => {
          items.push({
            estado: item.state,
            comprobante: item.recipt,
            total: item.amount,
            saldo: item.amountPending,
            fechaPago: item.datePayment,
            metodoPago: item.methodPayment,
          });
        });

        if (items.length > 0) {
          this.uiService.showSpinner(true);

          const structure = [
            {header: 'Estado', body : 'estado'},
            {header: 'Comprobante', body : 'comprobante'},
            {header: 'Total', body : 'total'},
            {header: 'Saldo', body : 'saldo'},
            {header: 'Fecha de pago', body : 'fechaPago'},
            {header: 'Método de pago', body : 'metodoPago'}
          ];

          this.listExportService.downloadFile(type, 'Listado de pagos', structure, items).then((response) => {
            this.uiService.showSpinner(false);
          });
        }
      } else {
        this.uiService.showSpinner(false);
        this.uiService.showSnackBar('No existen registros para generar la exportación');
      }
    }).catch((error) => {
      this.uiService.showSpinner(false);
      this.uiService.dialogShow('Ups!', 'No es posible generar la exportación en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }
}
